/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

// Checks if all current permissions are selected
export const isAllPermissionsSelected = (
    currentPermissions = [],
    selectedPermissions = [],
) => {
    return (
        currentPermissions.length > 0 &&
        currentPermissions.every((permission) =>
            selectedPermissions.some((item) => item.id === permission.id),
        )
    );
};

/**
 * Counts the permissions of one module tab the role already has selected.
 *
 * A tab holds the permissions of its module and the ones of its children, and
 * the backend returns each of them under its own module id, so counting only
 * the id of the parent left every grouped tab (Buildings, Dining, Contractors,
 * Suppliers, Visitor management...) reporting zero.
 *
 * @param {Array} modulePermissions - Permissions belonging to the tab.
 * @param {Array} selectedPermissions - Permissions selected on the role.
 * @returns {number} Permissions of the tab that are selected.
 */
export const countSelectedPermissions = (modulePermissions = [], selectedPermissions = []) =>
    (selectedPermissions || []).filter((permission) =>
        (modulePermissions || []).some((item) => item.id === permission.id),
    ).length;

// Selects or deselects all current permissions
export const handleSelectAllPermissions = (
    checked,
    currentPermissions = [],
    setSelectedPermissions,
) => {
    if (checked) {
        setSelectedPermissions((prev = []) => {
            const existingIds = new Set(prev.map((item) => item.id));

            const permissionsToAdd = currentPermissions
                .filter((permission) => !existingIds.has(permission.id))
                .map((permission) => ({ id: permission.id }));

            return [...prev, ...permissionsToAdd];
        });
    } else {
        const currentIds = currentPermissions.map((permission) => permission.id);

        setSelectedPermissions((prev = []) =>
            prev.filter((item) => !currentIds.includes(item.id)),
        );
    }
};